(function() {
	var page         = $('.page'),
		header       = $('#header'),
		headerTop    = header.offset().top,
        headerHeight = header.outerHeight();

    if ($(document).scrollTop() > headerTop + headerHeight) {
        page.addClass('page--header-fixed');
    }

    $(document).scroll(function() {
        var scrollTop    = $(document).scrollTop();

        if (scrollTop > headerTop + headerHeight) {
            page.addClass('page--header-fixed');
        } else {
            page.removeClass('page--header-fixed');
        }
    });
  })();


// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/header/header.js